import buildApiParameters from './build-api-parameters';
import getUrlParameter from './get-url-parameter';

export default { buildApiParameters, getUrlParameter };
